import FirmwareList from './FirmwareList';
export default FirmwareList;
